import { axios } from '~/clients';
import { SUGGESTED_VEHICLES_URL } from '~/constants/endpoints';
import type { SuggestedVehiclesData } from '~/services/home/contracts';
import { BrowserCookies } from '~/utilities';
import { logError } from '~/utilities/errorHandlers';

type SuggestedVehiclesRequest = {
  zipCode: string;
};

export default async function fetchSuggestedVehicles(
  { zipCode }: SuggestedVehiclesRequest,
  controller: AbortController
): Promise<SuggestedVehiclesData> {
  try {
    const res = await axios.post(
      SUGGESTED_VEHICLES_URL,
      {
        numVehiclesToReturn: 12,
        zip5: zipCode,
        browserCookieId: BrowserCookies.get('BrowserCookieId')
      },
      {
        signal: controller.signal
      }
    );

    return res.data;
  } catch (err) {
    logError(err, { location: 'Fetch suggested vehicles' });

    return {
      vehicleSource: '',
      vehicles: []
    };
  }
}
